import { IgSwitch } from "@intelligems/ig-theme/IgSwitch";
import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import Stack from "@mui/material/Stack";

export const ItemSelectionToggle = ({
  checked,
  onChange,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
}) => (
  <Stack direction="row" justifyContent="space-between" spacing={2}>
    <Stack>
      <IgTypography>Allow item selection</IgTypography>
      {checked && (
        <IgTypography variant="body2" color="textSecondary">
          Customers choose which items to add. Discount updates as selection
          changes.
        </IgTypography>
      )}
    </Stack>
    <IgSwitch checked={checked} onChange={(_, value) => onChange(value)} />
  </Stack>
);
